export class UserServiceCenter {
	userServiceCenterId: number;
	serviceCenterId: number;
 	serviceCenterName: string;
	isDefault: boolean;
	integraCode: string;
	address: string;
}
